import assert from 'assert-ts';
import type {Schemas} from 'domainTypes/dto';
import {Concept} from 'types';
import type {BulkUpdateCreate, BulkUpdateFieldName} from '../types';

export const mapBulkUpdateWorkField = (
  dto: Schemas.BulkUpdateWorkField,
): Pick<BulkUpdateCreate, 'type' | 'bulkUpdateField'> => {
  if (dto.type === 'WORK') {
    return {
      type: Concept.work,
      bulkUpdateField: mapBulkUpdateWorkFieldName(dto.field),
    };
  }

  assert(false, 'mapBulkUpdateWorkField: Unexpected type', {dto});
};

export const mapToBulkUpdateWorkField = (
  dto: Pick<BulkUpdateCreate, 'type' | 'bulkUpdateField'>,
): Schemas.BulkUpdateWorkField => {
  if (dto.type === Concept.work) {
    return {
      type: 'WORK',
      field: mapToBulkUpdateWorkFieldName(dto.bulkUpdateField),
    };
  }

  assert(false, 'mapToBulkUpdateWorkField: Unexpected type', {dto});
};

const mapBulkUpdateWorkFieldName = (
  dto: Schemas.BulkUpdateWorkField['field'],
): BulkUpdateFieldName => {
  if (dto === 'seriesRelations') {
    return 'links';
  }

  return dto;
};

const mapToBulkUpdateWorkFieldName = (
  dto: BulkUpdateFieldName,
): Schemas.BulkUpdateWorkField['field'] => {
  if (dto === 'links') {
    return 'seriesRelations';
  }

  return dto;
};
